import { useState } from "react"
import styled from "styled-components"

import { PlusIcon, XIcon } from "@minuthq/meatball-ui-icons"
import { Button, Chip, colors, spacing } from "@minuthq/meatball-ui-react"

import { ContextTargetSelectDialog } from "src/components/MinutAI/MinutAIKnowledge/MinutAIContentLibrary/ContextTargetSelectDialog"
import { TContextTarget } from "src/components/MinutAI/minutAITypes"
import { useTranslate } from "src/i18n/useTranslate"

export function ContextTargetSelect({
  selectedTarget,
  onChangeTarget,
}: {
  selectedTarget: TContextTarget | null
  onChangeTarget: (target: TContextTarget | null) => void
}) {
  const { tPlaceholder } = useTranslate()

  const [showHomeSelection, setShowHomeSelection] = useState(false)

  return (
    <>
      <SelectionArea>
        {selectedTarget ? (
          <Chip
            Icon={XIcon}
            label={selectedTarget.name}
            onClick={() => onChangeTarget(null)}
            size="medium"
          />
        ) : (
          <Button
            variant="subtle"
            size="x-small"
            startIcon={<PlusIcon width={18} height={18} />}
            onClick={() => setShowHomeSelection(true)}
          >
            {tPlaceholder("Add")}
          </Button>
        )}
      </SelectionArea>

      {showHomeSelection && (
        <ContextTargetSelectDialog
          onClose={() => setShowHomeSelection(false)}
          onSelect={(target) => {
            onChangeTarget(target)
            setShowHomeSelection(false)
          }}
        />
      )}
    </>
  )
}

const SelectionArea = styled.div`
  background-color: ${colors.neutral};
  padding: ${spacing.M};
  border-radius: 0.5rem;
`
